export default __webpack_public_path__ + "static/media/pencil-icon.1c16a184.svg";